
import {Component} from '@angular/core';
import {EmSpinnerModule} from '@em/shared/ui';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
  selector: 'em-loading-cell-renderer',
  imports: [EmSpinnerModule],
  template: `@if (this.displayValue) {
  <span>{{ this.displayValue }}</span>
}
@if (!this.displayValue) {
  <em-spinner
    class="em-spinner-mini m-3"
  ></em-spinner>
}`,
  styleUrls: ['./loading-cell-renderer.scss'],
})
export class EmLoadingCellRendererComponent
  implements ICellRendererAngularComp
{
  displayValue!: string;

  agInit(params: ICellRendererParams): void {
    this.displayValue = params.value;
  }

  refresh() {
    return false;
  }
}
